export default function productPairsWellController() {
  const pairsWellWithElement = document.getElementById('pairs-well-with');

  if (!pairsWellWithElement) return;

  const swiperWrapper = pairsWellWithElement.querySelector('.swiper-wrapper');
  const loadingSpinnerHtml = pairsWellWithElement.querySelector('.loading-spinner-html').innerHTML;

  const maxProduct = parseInt(pairsWellWithElement.dataset.maxProduct, 10) || 5;

  const currentProductId = document.querySelector('product-info').dataset.productId;

  const renderPopup = pairsWellWithElement.dataset.renderPopup === 'true';
  const popupText = pairsWellWithElement.dataset.popupText || '';

  function getSingleBundleProductHtml(imgSrc, imgAlt, title, price, variantId, url) {
    if (!imgSrc || !title || !price || !variantId) return '';

    return `
        <div class="swiper-slide">
            <div class="pairs-well-with__item">
                <div class="pairs-well-with__thumbnail-wrapper">
                  <img src="${imgSrc}" alt="${imgAlt}">
                </div>
                <div class="pairs-well-with__information">
                    <a
                        href="${url}"
                        class="pairs-well-with__title font-heading-family"
                        data-title="${title}"
                    >
                        ${title}
                    </a>
                    <div class="pairs-well-with__price text-size-small font-body-bold">
                        ${price}
                    </div>
                </div>
                <button
                    type="button"
                    class="pairs-well-with__add-to-cart button add-to-cart-button"
                    data-variant-id="${variantId}"
                >
                    <span class="button-text visually-hidden">Add to Cart</span>
                    ${loadingSpinnerHtml}
                </button>
            </div>
        </div>
    `;
  }

  waitForElement(
    (container, target) => {
      const products = target.querySelectorAll('.bndlr-product');

      if (!products || !products.length) {
        return;
      }

      let productIndex = 0;
      for (const productEl of products) {
        if (productIndex >= maxProduct) {
          break;
        }

        const productId = productEl.dataset.productId;

        if (productId == currentProductId) {
          continue;
        }

        const available = productEl.dataset.available === 'true';

        if (!available) {
          continue;
        }

        let variantId = null;
        let oldPrice = null;
        let newPrice = null;
        let title = null;
        let href = null;
        let imgSrc = null;
        let imgAlt = null;

        const priceWrapperEl = productEl.querySelector('.bndlr-product-price');
        const oldPriceEl = priceWrapperEl.querySelector('.bndlr-old-price');
        const newPriceEl = priceWrapperEl.querySelector('.bndlr-new-price');

        const titleEl = productEl.querySelector('.bndlr-product-title');

        const imgEl = productEl.querySelector('.bndlr-product-image');

        const variantSelect = productEl.querySelector('.bndlr-select-variant');

        if (oldPriceEl) {
          oldPrice = getOwnTextContent(oldPriceEl);
        }

        if (newPriceEl) {
          newPrice = getOwnTextContent(newPriceEl);
        }

        if (titleEl) {
          title = getOwnTextContent(titleEl);
          href = titleEl.href;
        }

        if (imgEl) {
          imgSrc = imgEl.src;
          imgAlt = imgEl.alt;
        }

        if (variantSelect) {
          variantId = +variantSelect.value;
        }

        const oldPriceNewHtml = oldPrice ? `<span class="old-price">${oldPrice}</span>` : '';
        const newPriceNewHtml = newPrice ? `<span class="new-price">${newPrice}</span>` : '';
        const priceNewHtml = oldPriceNewHtml + newPriceNewHtml;

        productIndex++;

        const productElNewHtml = getSingleBundleProductHtml(imgSrc, imgAlt, title, priceNewHtml, variantId, href);
        swiperWrapper.insertAdjacentHTML('beforeend', productElNewHtml);
      }

      const addToCartButtons = pairsWellWithElement.querySelectorAll('.pairs-well-with__add-to-cart');

      if (!addToCartButtons || !addToCartButtons.length) return;

      addToCartButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          // Disable button to prevent multiple clicks
          if (button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true') {
            return;
          }

          const variantId = button.dataset.variantId;

          button.classList.add('loading');
          button.setAttribute('aria-disabled', 'true');

          addToCart(variantId).finally(() => {
            button.classList.remove('loading');
            button.setAttribute('aria-disabled', 'false');
          });
        });
      });

      if (productIndex > 0) {
        pairsWellWithElement.classList.remove('hidden');
      }
    },
    '.product__info-container',
    '.bndlr-mnm-available-products'
  );

  if (renderPopup) {
    function getBundleDiscount() {
      if (!window.bndlr) {
        return 0;
      }

      const bundles = window.bndlr.getBundles();

      return !bundles || !bundles.length ? 0 : +bundles[0].percentage_value / 100;
    }

    function getBundleItems() {
      if (!window.bndlr) {
        return [];
      }

      const bundles = window.bndlr.getBundles();

      return !bundles || !bundles.length ? [] : Object.values(bundles[0].products);
    }

    function renderBundleSavingsPopup(items) {
      const [savings, total] = items.reduce(
        (acc, item) => {
          return [acc[0] + item.savings * item.quantity, acc[1] + item.newPrice * item.quantity];
        },
        [0, 0]
      );

      if (document.getElementById('bundle-go-to-checkout-popup')) {
        const titleEl = document.querySelector('.bundle-go-to-checkout-popup__title');
        titleEl.innerHTML = preparePopupText(savings, total);

        document.getElementById('bundle-go-to-checkout-popup').classList.toggle('active', savings > 0);

        return;
      }

      if (savings <= 0) {
        return;
      }

      const html = `
        <div class="bundle-go-to-checkout-popup__wrapper global-padding">
          <div class="bundle-go-to-checkout-popup__inner page-width">
            <div class="bundle-go-to-checkout-popup color-scheme-1 gradient" id="bundle-go-to-checkout-popup">
              <div class="bundle-go-to-checkout-popup__header">
                  <div class="bundle-go-to-checkout-popup__close" aria-label="Close"></div>
              </div>
              <div class="bundle-go-to-checkout-popup__title">${preparePopupText(savings, total)}</div>
              <form action="/cart" method="post" id="bundle-go-to-checkout-popup__form">
                  <button
                      class="button button--primary button--full-width button--small"
                      name="checkout"
                  >
                      Check out
                  </button>
              </form>
            </div>
          </div>
        </div>
      `;

      document.body.insertAdjacentHTML('beforeend', html);

      setTimeout(() => {
        document.getElementById('bundle-go-to-checkout-popup').classList.add('active');
      }, 50);

      document.querySelector('.bundle-go-to-checkout-popup__close').addEventListener('click', function () {
        document.getElementById('bundle-go-to-checkout-popup').classList.remove('active');
      });

      const quickAdd = document.querySelector('.quick-add__wrapper');

      if (quickAdd) {
        onElementClassChanged(quickAdd, (classList) => {
          document
            .getElementById('bundle-go-to-checkout-popup')
            .classList.toggle('apply-additional-offset', !classList.contains('hidden'));
        });

        document
          .getElementById('bundle-go-to-checkout-popup')
          .classList.toggle('apply-additional-offset', !quickAdd.classList.contains('hidden'));
      }
    }

    function preparePopupText(saving, total) {
      const replacements = {
        savings: `<span class="savings font-body-bold">${intlFormatMoney(saving)}</span>`,
        total: `<span class="total font-body-bold">${intlFormatMoney(total)}</span>`,
      };

      return popupText.replace(/%([^%]+)%/g, (_, key) => {
        return replacements[key] || `%${key}%`;
      });
    }

    const updateBundleSavingsPopup = debounce((cartItems) => {
      const bundleItemsInCart = [];

      const bundleDiscount = getBundleDiscount();
      const bundleItems = getBundleItems();

      bundleItems.forEach((bundleItem) => {
        const bundleVariants = Object.keys(bundleItem.variants);

        const cartItem = cartItems.find((cartItem) =>
          bundleVariants.some((variantId) => variantId == cartItem.variant_id)
        );

        if (!cartItem) return;

        const oldPrice = cartItem.price / 100;
        const newPrice = oldPrice * (1 - bundleDiscount);
        const savings = oldPrice - newPrice;

        bundleItemsInCart.push({
          quantity: cartItem.quantity,
          oldPrice,
          newPrice,
          savings,
        });
      });

      renderBundleSavingsPopup(bundleItemsInCart);
    }, 100);

    document.addEventListener('cart:updated', function (event) {
      updateBundleSavingsPopup(event.detail.items);
    });
  }
}
